export { HTTPResponseEntity as default };

/**
* HTTP Response Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class HTTPResponseEntity {
  /**
   * Defines if response success
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  success;

  /**
   * Parsed results
   *
   * @public
   *
   * @type {*}
   *
   * @since 7.0.0
   */
  results;

  /**
   * Response messages
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  messages;
}